<template>
  <q-page fluid style="min-height: 0px">
    <div class="row">
      <div ref="titleOfPage" class="col-12 text-center bg-primary text-white">
        <h4 class="q-py-none q-mb-md pwa-heading">Device Controller</h4>
      </div>

      <div class="col-12 q-mt-md">
        <q-btn size="md" class="full-width" outline> Raise Platform </q-btn>
      </div>
      <div class="col-12 q-mt-md">
        <q-btn size="md" class="full-width" outline> Lower Platform </q-btn>
      </div>
      <div class="col-12 q-mt-md">
        <q-btn size="md" class="full-width" outline> Stop Scan </q-btn>
      </div>

      <div ref="footerOfPage" class="col-12 q-pa-md">
        <div style="width: 150px; margin: auto; position: relative">
          <q-img src="/statics/TDRI_Logo_Light.png" spinner-color="white" />
        </div>
      </div>
    </div>
  </q-page>
</template>

<script>
import { QSpinnerGears } from "quasar";
import { mapGetters } from "vuex";
import moment from "moment";

export default {
  components: {},
  computed: {
    ...mapGetters(["currentUser"]),
  },
  props: {
    source: String,
  },
  watch: {},
  data: () => ({
    formData: {},
  }),
  mounted() {
    setTimeout(() => {
      this.maxHeight =
        this.$refs.titleOfPage.clientHeight +
        this.$refs.footerOfPage.clientHeight +
        20;
    }, 100);
  },
  methods: {
    handleClick(evt, row, index) {
      this.selected = [row];
    },
    handleDoubleClick(evt, row, index) {
      this.$router.push("/mobile-view/mp-survey");
    },
    stopScan() {
      this.$q.loading.show({
        message: "Stopping Scan",
        spinner: QSpinnerGears,
      });
      this.$store.dispatch("resetDeviceScanStartTime");
      this.$store
        .dispatch("runDeviceCommand", {
          ep: "device/StopRecording",
          command: "StopRecording",
          payload: {},
        })
        .then((res) => {
          this.$q.loading.hide();
          if (res == "Success") {
            this.$emit("changeView", "stoppedSurvey");
          } else {
            this.$swal({
              title: "Error",
              text: "There was an issue communication with the Device, Please try again",
              type: "warning",
              confirmButtonText: "Retry",
              confirmButtonColor: "#3284E3",
            }).then((res) => {
              if (res.value) {
                this.stopScan();
              }
            });
          }
        });
    },
    lowerPlatform() {
      this.$q.loading.show({
        message: "Lowering Platform",
        spinner: QSpinnerGears,
      });
      this.$store.dispatch("changePlatformPosition", "Low").then((res) => {
        this.$q.loading.hide();
        if (res == "Error") {
          this.$swal({
            title: "Error",
            text: "There was an issue communication with the Device, Please try again",
            type: "warning",
            confirmButtonText: "Retry",
            confirmButtonColor: "#3284E3",
          }).then((res) => {
            if (res.value) {
              this.lowerPlatform();
            }
          });
        }
      });
    },
    raisePlatform() {
      this.$q.loading.show({
        message: "Raising Platform",
        spinner: QSpinnerGears,
      });
      this.$store.dispatch("changePlatformPosition", "High").then((res) => {
        this.$q.loading.hide();
        if (res == "Error") {
          this.$swal({
            title: "Error",
            text: "There was an issue communication with the Device, Please try again",
            type: "warning",
            confirmButtonText: "Retry",
            confirmButtonColor: "#3284E3",
          }).then((res) => {
            if (res.value) {
              this.raisePlatform();
            }
          });
        }
      });
    },
  },
};
</script>
